const s = (e, n) => {
  var r;
  const t = (r = e.data) == null ? void 0 : r[n];
  return `${t == null ? void 0 : t.entityName}, ${t == null ? void 0 : t.entityAddress}, ${(t == null ? void 0 : t.badge) || ""}`;
}, d = (e, n) => {
  const t = e.newValue.split(",");
  return e.data[n].entityName = t[0], e.data[n].entityAddress = t[1], e.data[n].badge = t[2], !0;
};
export {
  s as entityCellValueGetter,
  d as entityCellValueSetter
};
//# sourceMappingURL=index.es557.js.map
